<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let orderStatus: "none" | "asc" | "desc" = "none";
	export let deactivatedFillColor = "#bcbfc3";
	export let activatedFillColor = "#46474b";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 16 17">
	<g>
		<path
			d="M7.293.707a1 1 0 0 1 1.414 0l5.586 5.586A1 1 0 0 1 13.586 8H2.414a1 1 0 0 1-.707-1.707z"
			fill={orderStatus === 'asc' ? activatedFillColor : deactivatedFillColor} />
		<path
			d="M7.293.707a1 1 0 0 1 1.414 0l5.586 5.586A1 1 0 0 1 13.586 8H2.414a1 1 0 0 1-.707-1.707z"
			transform="rotate(180 8 8.5)"
			fill={orderStatus === 'desc' ? activatedFillColor : deactivatedFillColor} />
	</g>
</svg>

<style lang="scss">
</style>
